import { get } from 'lodash';
import { SingleLineField } from '../../../components/Form/Fields';

const summaryRender = (code) => [
  {
    name: 'autorisation',
    value: get(code, 'authorizationNumber', '-')
  }
];

const associatedFields = [
  {
    label: 'No Autorisation',
    getName: (index) => `codes[${index}].authorizationNumber`,
    type: SingleLineField
  }
];

const noAutorisation = { associatedFields, summaryRender };

export default noAutorisation;
